import workspaceQuery from 'graphql/queries/sales/CustomerContractReferenceWorkspaceQuery.graphql';
import instanceQuery from 'graphql/queries/sales/CustomerContractReferenceQuery.graphql';
import fragment from 'graphql/fragments/sales/CustomerContractReferenceFragment.graphql';
import defaultQuery from 'graphql/queries/sales/CustomerContractReferenceDefault.graphql';
import mutationQuery from 'graphql/mutations/sales/CustomerContractReferenceMutation.graphql';
import listQuery from 'graphql/queries/sales/CustomerContractReferenceListQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const CustomerContractReference: EntityType = {
  type: 'CustomerContractReference',
  title: 'Customer Contract References',
  formTitle: 'Customer Contract Reference',
  formUrl: '/Sales/CustomerPricing/CustomerContractReference/Details/',
  workspaceUrl: '/Sales/CustomerPricing/CustomerContractReference/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'reference',
    remoteFilter: false,
  },
  fragment,
  screenReference: 'CUSTOMER_CONTRACT_REFERENCE',
};

export default CustomerContractReference;
